import React from 'react'
import APIS from '../../constant/EndPoint'
import ComboboxInput from '../Reusable/Form/ComboboxInput'
import TextField from '../Reusable/Form/TextInput'
import NumberField from '../Reusable/Form/NumberField'

const WarehosueForm = ({ register, errors, setValue, getValues, clearErrors }: any) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-x-4 mx-4">
        <TextField
          label={"Warehosue Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"Primary Email"}
          register={register("primary_email")}
          errors={errors?.primary_email}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <NumberField
          setValue={setValue}
          clearErrors={clearErrors}
          label={"Primary Contact"}
          register={register("primary_contact")}
          errors={errors?.primary_contact}
          value={getValues().primary_contact}
        />
        <NumberField
          value={getValues().secondary_contact}
          setValue={setValue}
          clearErrors={clearErrors}
          label={"Secondary Contact"}
          register={register("secondary_contact")}
          errors={errors?.secondary_contact}
        />

      </div>
      <div className="w-full my-2 text-left mx-4">
        <p>Address</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <ComboboxInput
          label={"Country"}
          placeholder={"Search Country"}
          url={APIS.LOCATION}
          props={{ level: 0 }}
          queryKey={"country"}
          register={register("country")}
          errors={errors?.country}
          name={"country"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"State"}
          placeholder={"State"}
          url={APIS.LOCATION}
          props={{ level: 1 }}
          queryKey={"state"}
          register={register("state")}
          errors={errors?.state}
          name={"state"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"District"}
          placeholder={"District"}
          url={APIS.LOCATION}
          props={{ level: 2 }}
          queryKey={"district"}
          register={register("district")}
          errors={errors?.district}
          name={"district"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"City"}
          placeholder={"City"}
          url={APIS.LOCATION}
          props={{ level: 3 }}
          queryKey={"city"}
          register={register("city")}
          errors={errors?.city}
          name={"city"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Landmark"}
          register={register("landmark")}
          errors={errors?.landmark}
        />
        <ComboboxInput
          label={"Warehouse Manager"}
          placeholder={"Warehouse Manager"}
          url={APIS.STAFF}
          queryKey={"staff"}
          register={register("warehouse_manager")}
          errors={errors?.warehouse_manager}
          name={"warehouse_manager"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
    </>
  )
}

export default WarehosueForm
